// Logos dos clientes
import comtrafo from '../assets/clients/comtrafo.png';
import enertrafo from '../assets/clients/Enertrafo.png';
import romagnole from '../assets/clients/romagnole.png';
import cepel from '../assets/clients/cepel.png';
import weg from '../assets/clients/WegLogo.png';
import equatorial from '../assets/clients/LogoEquatorial.png';

const clientsLogos = [
    weg,
    romagnole,
    comtrafo,
    enertrafo,
    cepel,
    equatorial
];

export default clientsLogos;
